import { render, staticRenderFns } from "./GeneralConfigure.vue?vue&type=template&id=4769e1c8&scoped=true&"
import script from "./GeneralConfigure.vue?vue&type=script&lang=tsx&"
export * from "./GeneralConfigure.vue?vue&type=script&lang=tsx&"
import style0 from "./GeneralConfigure.vue?vue&type=style&index=0&id=4769e1c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4769e1c8",
  null
  
)

export default component.exports